import styled from "@emotion/styled";
import { SetInterviewTypeAction } from "../../redux/actions/InterviewActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import SuggestionRow from "../../shared/components/SuggestionRow";
import InterviewType, { textForInterviewType } from "../../shared/enums/InterviewType";

const StyledRow = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    maxWidth: '100%',
    gap: '15px',
}));

const InterviewTypeSelection = () => {
    const savedJobs = useAppSelector(store => store.savedJobsState.jobsArray);
    const dispatch = useAppDispatch();

    const onTypeOfInterviewSelected = (interviewType: InterviewType) => {
        dispatch(SetInterviewTypeAction(interviewType));
    }

    return (
        <StyledRow>
            {Object.values(InterviewType).map((type, index) => {
                if (type === InterviewType.job && savedJobs.length === 0) return undefined;
                return <SuggestionRow key={index} title={textForInterviewType(type)} onClick={() => onTypeOfInterviewSelected(type)} />
            })}
        </StyledRow>
    )
}

export default InterviewTypeSelection